import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "../../shared/Spinner";
import { EmptyContentContainer } from "./style";

interface IEmptyContentProps {
  loading?: boolean;
  showConnectWallet?: boolean;
  emptyText: string;
  /** Shown under the text, e.g. a Retry button for a failed load. */
  action?: ReactNode;
}

function EmptyContent({
  loading,
  showConnectWallet,
  emptyText,
  action,
}: IEmptyContentProps) {
  const { t } = useTranslation("app", { keyPrefix: "PortfolioSettings.Table.EmptyContent" });

  const text = showConnectWallet
    ? t("connect_wallet_desc")
    : emptyText;

  return (
    <EmptyContentContainer>
      {
        // eslint-disable-next-line no-nested-ternary
        loading ? (
          <Spinner />
        ) : (
          <>
            {text}
            {!showConnectWallet && action}
          </>
        )
      }
    </EmptyContentContainer>
  );
}

export default EmptyContent;
